module.exports = __webpack_public_path__ + "cc345b33b43acebca5a5b925482bb91c.pdf";